import {observable, action, autorun} from 'mobx'
import {notification} from 'antd'

export class Permissions {
  @observable list = {}
  @observable modal = false
  @observable closeable = true
  @observable modalText
  @observable buttonLink
  @observable buttonText

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  invalidEmail = autorun(() => {
    if (this.root && this.root.user.data.is_email_verified && this.list.find(row => row.reason && row.reason.charcode === 5013)) {
      this.root.user.data.is_email_verified = false
    }
  })

  @action set(permissions) {
    this.list = Object.assign(this.list, permissions)
  }

  @action check = (permission) => {
    if (!this.list[permission]) {
      return false
    }

    if (permission == 'account.sms_notifications.enable') {
      if (this.list[permission].reason && this.list[permission].reason.code == 5015) {
        return true
      }
    }

    return this.list[permission].is_granted
  }

  @action checkUpgrade = (permission) => {
    if (!this.list[permission] || !this.list[permission].reason) {
      return false
    }

    return [5019, 5020, 5021, 5022, 5024].indexOf(this.list[permission].reason.code) !== -1
  }

  @action async loadList() {
    try {
      const res = await this.api.request('user/permissions', 'get')
      for (let name in res) {
        this.set(res[name])
        this.checkSideEffect(res[name])
      }
    } catch (e) {
      notification['error']({
        message: 'Failed to load permissions list',
        description: e.message || 'Unknown error'
      })
    }
  }

  @action async loadSingle(permission) {
    try {
      const res = await this.api.request(`user/permissions/${permission}`, 'get')
      this.set(res)
      this.checkSideEffect(res)
    } catch (e) {
      notification['error']({
        message: 'Failed to load permission',
        description: e.message || 'Unknown error'
      })
    }
  }

  @action showModal = (
    closeable = true,
    text = 'This feature is not supported in your subscription plan. Please click below to upgrade',
    buttonLink = '/upgrade',
    buttonText = 'Upgrade'
  ) => {
    this.closeable = closeable
    this.modalText = text
    this.buttonLink = buttonLink
    this.buttonText = buttonText
    this.modal = true
  }

  @action hideModal = () => {
    this.modal = false
  }

  @action checkSideEffect(permission) {
    if (permission.reason && permission.reason.code) {
      const {code} = permission.reason
      if (code === 5010 || code === 5011) {
        this.root.auth.logout()
      } else if (code === 5012) {
        this.root.user.data.is_subscribed = false
      } else if (code === 5013) {
        this.root.user.data.is_email_verified = false
      }
    }
  }

  @action wrap(name, callback, closeable = true) {
    const permission = this.list[name]
    if (!this.check(name)) {
      const code = permission.reason ? permission.reason.code : null
      switch (code) {
      case 5014:
        this.showModal(closeable, 'Email is not valid. Please click below to go to your account settings', '/profile', 'To Account Settings')
        break
      case 5015:
        this.showModal(closeable, 'Phone is not valid. Please click below to go to your account settings', '/profile', 'To Account Settings')
        break
      case 5019:
        this.showModal(closeable, 'You have exceeded the max number of Algos included in your account. Please click here to upgrade.')
        break
      case 5020:
        this.showModal(closeable, 'This feature is not supported in your subscription plan. Please click below to upgrade.')
        break
      case 5021:
        this.showModal(closeable, 'You have exceeded the max number of Algos included in your account. Please click here to upgrade.')
        break
      case 5022:
        this.showModal(closeable, 'Cryptocurrency is not supported in your subcription plan. Please click below to upgrade.')
        break
      case 5023:
        this.showModal(closeable, 'Intraday data is available through Interactive broker\'s market data subscription. Go to your profile to activate IB connection.', '/profile?tab=broker', 'To IB Settings')
        break
      case 5024:
        this.showModal(closeable, 'Alternative data is not supported in your subcription plan. Please click below to upgrade.')
        break
      case 5025:
        this.showModal(closeable, 'Your backtest window is limited to one year with a Lite account. Please upgrade to expand.')
        break
      case 5026:
        this.showModal(closeable, 'Valid IB account is required for this action. Go to your profile to activate IB connection.', '/profile?tab=broker', 'To IB Settings')
        break
      default:
        this.showModal(closeable, 'Action is permitted. Contact us to learn more.', '/contact', 'Contact Us')
        break
      }
      return
    }
    if (typeof callback === 'function') {
      callback()
    }
  }
}
